module.exports = fox._r("fonts/activity.eot", __webpack_public_path__ + "_/_/_/root/fonts/1fjZ15u.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/activity.eot
// module id = 49
// module chunks = 4